import { getDialogInfo } from "@/utils/dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { Popup } from "@progress/kendo-react-popup";
import { MoreHorizontal, PencilLine, Trash2 } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { CustomDialogBox } from "./Dialog";
import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { Switch } from "@progress/kendo-react-inputs";
import { ILevel } from "@/interfaces/level.interface";
import { ICompany } from "@/interfaces/company.interface";

export const ActionCellPopupSettings = (props: any) => {
  const { rowData, handleEditClick, dataKey } = props;
  const anchor = useRef(null);
  const [show, setShow] = useState(false);

  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setShow(false);
  }, []);

  const onClick = () => {
    setShow(!show);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <td className="text-end ">
        <div className="flex items-center gap-x-2 group">
          <div className="self-center cursor-pointer hover:underline hover:text-primaryMain">
            {rowData && dataKey && rowData[dataKey]}
          </div>
          <div className={`mt-[3px] text-end`}>
            <button
              className={`px-2 [&.active]:opacity-100 [&.active]:visible opacity-0 invisible cta_dropdown  transition-all duration-300 `}
              onClick={onClick}
              ref={anchor}
            >
              <MoreHorizontal strokeWidth={1} />
            </button>
            <Popup
              anchor={anchor.current}
              show={show}
              popupClass={"w-[161px]"}
              anchorAlign={{ horizontal: "right", vertical: "top" }}
              popupAlign={{ horizontal: "left", vertical: "top" }}
            >
              <div ref={popupRef}>
                <Button
                  className="w-full iconBtn px-1"
                  fillMode="flat"
                  onClick={() => {
                    setShow(false);
                    handleEditClick(rowData);
                  }}
                >
                  <span className="inline-flex items-center gap-2 w-full">
                    <PencilLine className="w-4 h-4" />
                    <span className="flex-1 text-sm font-normal">Edit</span>
                  </span>
                </Button>
              </div>
            </Popup>
          </div>
        </div>
      </td>
    </>
  );
};

export const ToggleLevelActiveCell = (
  props: GridCustomCellProps & { enableDisable: (dataItem: ILevel) => void }
) => {
  const handleEnableDisable = async () => {
    props.enableDisable(props.dataItem);
  };

  return (
    <td>
      <Switch
        checked={props.dataItem.isActive}
        onLabel="Yes"
        offLabel="No"
        name="IsDeleted"
        value={!props.dataItem.IsDeleted}
        onChange={handleEnableDisable}
      ></Switch>
    </td>
  );
};

export const ToggleCompanyActiveCell = (
  props: GridCustomCellProps & {
    enableDisable: (dataItem: ICompany) => void;
    disabeled: boolean;
  }
) => {
  const handleEnableDisable = async () => {
    props.enableDisable(props.dataItem);
  };

  return (
    <td>
      <Switch
        checked={props.dataItem.isActive}
        onLabel="Yes"
        offLabel="No"
        disabled={props.disabeled}
        name="IsDeleted"
        value={!props.dataItem.IsDeleted}
        onChange={handleEnableDisable}
      ></Switch>
    </td>
  );
};
